//#region src/bite_log_chase_event.ts
let BiteLogChaseEvent = /* @__PURE__ */ function(BiteLogChaseEvent) {
	BiteLogChaseEvent[BiteLogChaseEvent["None"] = 0] = "None";
	BiteLogChaseEvent[BiteLogChaseEvent["TerminalConnected"] = 1] = "TerminalConnected";
	BiteLogChaseEvent[BiteLogChaseEvent["TerminalDisconnected"] = 2] = "TerminalDisconnected";
	BiteLogChaseEvent[BiteLogChaseEvent["SaleTransaction"] = 3] = "SaleTransaction";
	BiteLogChaseEvent[BiteLogChaseEvent["SaleTransactionError"] = 4] = "SaleTransactionError";
	BiteLogChaseEvent[BiteLogChaseEvent["DeviceSetup"] = 5] = "DeviceSetup";
	BiteLogChaseEvent[BiteLogChaseEvent["CloseTransaction"] = 6] = "CloseTransaction";
	BiteLogChaseEvent[BiteLogChaseEvent["CloseTransactionError"] = 7] = "CloseTransactionError";
	BiteLogChaseEvent[BiteLogChaseEvent["RefundTransactionRequested"] = 8] = "RefundTransactionRequested";
	BiteLogChaseEvent[BiteLogChaseEvent["RefundTransaction"] = 9] = "RefundTransaction";
	BiteLogChaseEvent[BiteLogChaseEvent["RefundTransactionError"] = 10] = "RefundTransactionError";
	BiteLogChaseEvent[BiteLogChaseEvent["Logs"] = 11] = "Logs";
	return BiteLogChaseEvent;
}({});
//#endregion
export { BiteLogChaseEvent };

//# sourceMappingURL=bite_log_chase_event.js.map